import { render, staticRenderFns } from "./DataViewDocument.vue?vue&type=template&id=f8da403e&"
import script from "./DataViewDocument.vue?vue&type=script&lang=js&"
export * from "./DataViewDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports